import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=1fd26c66&scoped=true&"
import script from "./AccordionGroup.vue?vue&type=script&lang=js&"
export * from "./AccordionGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroup.vue?vue&type=style&index=0&id=1fd26c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd26c66",
  null
  
)

export default component.exports